import { render } from "./beranda-direktori.vue?vue&type=template&id=3c56879e&scoped=true"
import script from "./beranda-direktori.vue?vue&type=script&lang=js"
export * from "./beranda-direktori.vue?vue&type=script&lang=js"

import "./beranda-direktori.vue?vue&type=style&index=0&id=3c56879e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c56879e"]])

export default __exports__